import React, { useState } from "react";
import "./style.scss";
import CreateSet from "../../../components/Guidelines/CreateSet";
const CreateSetPage = () => {
  return (
    <div className="createset_page_wrapper">
      <CreateSet />
    </div>
  );
};
export default CreateSetPage;
